import { FacilityAndSpaceFeatures, SpacePickerParams, UnitInterface } from "@swivl-mono/types";

export class SpacePickerHelpers {
  static imageAndTextURLForSpace = (space: UnitInterface, params: SpacePickerParams) => {
    let imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png";
    let text = params.sizeSmallDescription;

    const features = space?.features ?? [];

    // parking unit types
    if (features.includes(FacilityAndSpaceFeatures.RVParking)) {
      imageURL = this.getRVImage(features);
      text = params.sizeParkingDescription;
    } else if (features.includes(FacilityAndSpaceFeatures.BoatParking)) {
      imageURL = this.getBoatImage(features);
      text = params.sizeParkingDescription;
    } else if (features.includes(FacilityAndSpaceFeatures.Parking)) {
      imageURL = this.getCarParkingImage(features);
      text = params.sizeParkingDescription;
    }

    // other unit types
    else if (features.includes(FacilityAndSpaceFeatures.CommercialWarehouse)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-commercial-warehouse%402x.png";
    } else if (features.includes(FacilityAndSpaceFeatures.Locker)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-locker%402x.png";
    } else if (features.includes(FacilityAndSpaceFeatures.OfficeSpace)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-office-space%402x.png";
    } else if (features.includes(FacilityAndSpaceFeatures.SafetyDepositBox)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-security-deposit-box%402x.png";
    } else if (features.includes(FacilityAndSpaceFeatures.WineStorage)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-wine%402x.png";
    } else if (features.includes(FacilityAndSpaceFeatures.GunStorage)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-gun.png";
    }

    // fallback to size-based generic units
    else if (space?.width && space?.length) {
      const sqft = space.width * space.length;
      ({ imageURL, text } = this.getSizeImageAndText(sqft, params));
    }

    return { imageURL, text };
  };

  // unit type image helpers
  private static getCarParkingImage(features: FacilityAndSpaceFeatures[]) {
    if (features.includes(FacilityAndSpaceFeatures.Covered)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-car%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Enclosed)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-car%402x.png";
    }
    return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-car%402x.png";
  }

  private static getRVImage(features: FacilityAndSpaceFeatures[]) {
    if (features.includes(FacilityAndSpaceFeatures.Covered)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-rv%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Enclosed)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-rv%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Paved) && features.includes(FacilityAndSpaceFeatures.PullThru)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-pullthru-paved-rv%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Unpaved) && features.includes(FacilityAndSpaceFeatures.PullThru)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-pullthru-unpaved-rv%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Unpaved)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-unpaved-rv%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Paved)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-paved-rv%402x.png";
    }
    return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-rv%402x.png";
  }

  private static getBoatImage(features: FacilityAndSpaceFeatures[]) {
    if (features.includes(FacilityAndSpaceFeatures.Covered)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-boat%402x.png";
    }
    if (features.includes(FacilityAndSpaceFeatures.Enclosed)) {
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-boat%402x.png";
    }
    return "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-boat%402x.png";
  }

  private static getSizeImageAndText(sqft: number, params: SpacePickerParams) {
    if (sqft <= params.smallMaxSize) {
      return {
        imageURL: "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png",
        text: params.sizeSmallDescription
      };
    }
    if (sqft <= params.mediumMaxSize) {
      return {
        imageURL: "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-medium%402x.png",
        text: params.sizeMediumDescription
      };
    }
    if (sqft <= params.largeMaxSize) {
      return {
        imageURL: "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-large%402x.png",
        text: params.sizeLargeDescription
      };
    }
    return {
      imageURL: "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-extra-large%402x.png",
      text: params.sizeExtraLargeDescription
    };
  }
}
